import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { FaSpinner, FaUserSecret } from 'react-icons/fa';

import { loadUser } from '../../../redux/modules/user';

class Impersona extends Component {

  componentDidMount() {

    const token = this.props.location.query.t;

    if (token) {
      localStorage.clear();
      localStorage.setItem('token', token);
      this.props.loadUser()
      setTimeout(() => {
        this.props.router.push('/')
      }, 2000);
    } else {
      console.error('No token provided')
    }
  }


  render() {

    return (
      <div className="Impersona">
        <div className="container" style={{paddingTop: 40, paddingBottom: 40, textAlign: 'center'}}>

          <FaSpinner className="pulse" style={{fontSize: 30, color: '#ccc'}} />
        
          <h1>Sto mettendo la maschera...</h1>

          <FaUserSecret style={{fontSize: 200, color: '#ccc', marginTop: 50}} />

        </div>
      </div>
    );
  }
}

Impersona = withRouter(Impersona);

export default connect(null, { loadUser })(Impersona);
